<div class="club-socio-page">
    <app-recurring-payment-menu></app-recurring-payment-menu>
</div>
